import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  about: []
}

// mutations
export const mutations = {
  [types.SET_ABOUT] (state, about) {
    state.about = about
  }
}

// actions
export const actions = {
  async fetchAbout ({ commit }, payload) {
    try {
      const { data } = await axios.get(`/api/abouts/1/`)
      commit(types.SET_ABOUT, data)
    } catch (e) {
      console.log(e)
    }
  },

  async updateAbout({ commit }, payload){
    try {
        const { data } = await axios.put(`/api/abouts/1/`, payload)
        commit(types.SET_ABOUT, data)
      } catch (e) {
        console.log(e)
      }
  }
}

// getters
export const getters = {
  about: state => state.about
}




// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/about.js